'use client'

import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'

import { S3_PREFIX } from '@/shared/constants'
import { getSlugUrl } from '@/shared/utils'
import CustomLink from '../../customLink'
import MyImage from '../../myImage'

export default function HeaderDropdown({ subMenu }: any) {
  return (
    <div className="h-64 z-30 absolute transition-all mt-0.5 left-0 w-full text-center dark:bg-[#10171B] bg-white group-hover:visible group-hover:block invisible hidden group-hover:opacity-100 opacity-0">
      <div className="container px-6 relative w-[85%]">
        {/* Custom arrows (positioned absolutely) */}
        <div className="swiper-button-prev custom-swiper-arrow text-white left-0 w-6 h-6" />
        <div className="swiper-button-next custom-swiper-arrow text-white right-0 w-6 h-6" />

        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
          }}
          // spaceBetween={8}
          slidesPerView="auto"
          className="!overflow-hidden w-[80%]"
        >
          {subMenu.map((item: any) => (
            <SwiperSlide key={item?.oSeries?.oSeo?.sSlug} className="!w-[150px]">
              <li className="cursor-pointer transition-all px-4 flex-shrink-0 text-center h-full dark:hover:bg-headersActive dark:hover:border-b-buttonBg hover:border-b-underLine border-b-transparent border-b-[5px] relative group list-none">
                <CustomLink
                  href={getSlugUrl('/' + item?.oSeries?.oSeo?.sSlug)}
                  passHref
                  className="h-full w-full absolute top-0 left-0 opacity-0 z-30 !cursor-pointer"
                  prefetch={false}
                >
                  {item?.oSeries?.sTitle}
                </CustomLink>
                <div className="pt-10 flex-grow cursor-pointer">
                  <MyImage
                    loadOnScroll
                    className="mb-4 rounded-lg cursor-pointer border border-transparent h-[150px] object-cover"
                    src={
                      item?.oSeries?.oCategory?.oImg?.sUrl
                        ? `${S3_PREFIX}${item?.oSeries?.oCategory?.oImg?.sUrl}`
                        : ''
                    }
                    placeholderType="series"
                    height={200}
                    width={154}
                    alt={item?.oSeries?.oCategory?.oImg?.sText}
                  />
                  <span className="w-full text-wrap font-bold text-base line-clamp-2">
                    {item?.oSeries?.sSrtTitle || item?.oSeries?.sTitle}
                  </span>
                </div>
              </li>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
